export class DealerDetails {

    dealerId: string;
    dealerName: string;
    dealerNameHN: string;
    dealerCityCode: string;
    dealerAddress: string;
    dealerAddressHN: string;
    userId: string;

    constructor() {
        this.dealerId = "";
        this.dealerName = "";
        this.dealerNameHN = "";
        this.dealerCityCode = "";
        this.dealerAddress = "";
        this.dealerAddressHN = "";
        this.userId = "";

    }
}